import './wallet-list.scss';

import React from 'react';

import { useFetchCollectionsWallets } from '../../hooks/queries';
import { WalletList } from './wallet-list';
import { useHasPermission } from '../../hooks';
import { PERMISSIONS } from '../../config';

const CollectionsWalletList = ({ getCardExtra }) => {
  const hasPermission = useHasPermission();
  const canViewBalance = hasPermission(PERMISSIONS.BALANCE_VIEW);

  if (!canViewBalance) return null;

  const { walletsToDisplay, isLoading } = useFetchCollectionsWallets();
  return <WalletList wallets={walletsToDisplay} isLoading={isLoading} baseUrl="/wallets" getCardExtra={getCardExtra} />;
};

export { CollectionsWalletList };
